const React = require("react");

const ChangesLoader = (properties) => {
    if (properties.hidden || !properties.dateOfGeneration) {
        return null;
    }
    return (
        <>
            <div>
                Generated <span className={"utcWarn"}>(UTC)</span>
            </div>
            <div>
                {properties.dateOfGeneration}
                <button
                    type={"button"}
                    className={"no-border btn btn-default refreshButton"}
                    id={"reloadChangesButton"}
                    onClick={properties.onClick}
                    disabled={properties.disabled}
                >
                    <span className={"glyphicon glyphicon-refresh"} />
                </button>
            </div>
        </>
    );
};

module.exports = ChangesLoader;
